import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Publication from "./pages/Publication";
import Page from "./pages/Page";
import NotFound from "./pages/NotFound";
import { StaticContentContext } from "./Layout";

function App() {
  const { notFoundEndpoint } = useContext(StaticContentContext);
  return (
    <Routes>
      <Route
        path={notFoundEndpoint}
        element={<NotFound />}
      />
      <Route
        path="*"
        element={<Navigate to={notFoundEndpoint} />}
      />
      <Route
        path="/"
        element={<Home />}
      />
      <Route
        path={"/:slug"}
        element={<Page />}
      />
      <Route
        path={"/udgivelse/:id"}
        element={<Publication />}
      />
    </Routes>
  );
}

export default App;
